import { gql, useMutation } from "@apollo/client";

const LoginFromAuth0Mutation = gql`
  mutation loginFromAuth0($accessToken: String!) {
    loginFromAuth0(accessToken: $accessToken) {
      id
      name
      email
      firstName
      lastName
      picture
      subscriptionId
      subscriptionExpiresAt
      chartsCount
    }
  }
`;

type LoginFromAuth0MutationResponse = {
  id: string;
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
  subscriptionId: string | null;
  subscriptionExpiresAt: string | null;
  chartsCount: number;
};

export const useLoginFromAuth0Mutation = () =>
  useMutation<
    {
      loginFromAuth0: LoginFromAuth0MutationResponse;
    },
    {
      accessToken: string;
    }
  >(LoginFromAuth0Mutation);
